export enum TenantStatus {
  MOVE_IN = 'Moving in',
  MOVE_OUT = 'Moving out',
}

export enum Month {
  JANUARY = 'January',
  FEBRUARY = 'February',
  MARCH = 'March',
  APRIL = 'April',
  MAY = 'May',
  JUNE = 'June',
  JULY = 'July',
  AUGUST = 'August',
  SEPTEMBER = 'September',
  OCTOBER = 'October',
  NOVEMBER = 'November',
  DECEMBER = 'December',
}

export interface ProratedRentRawParams {
  tenantStatus?: TenantStatus;
  monthlyRent?: string;
  moveDate?: string;
}

export interface ProratedRentResult {
  dailyRent: number;
  days: number;
  month: Month;
}

export interface ProratedRentErrors {
  monthlyRent?: string;
  moveDate?: string;
}

interface ValidateSuccess {
  isValid: true;
}

interface ValidateError {
  isValid: false;
  errors: ProratedRentErrors;
}

export type ValidateResult = ValidateSuccess | ValidateError;

export type InternalTrackingCode = string;
export type TrackingCode = string;
